import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export type UseGlobalSearchResultsOptions = Readonly<{
    searchString: string;
    enabled?: boolean;
}>;

export function useGlobalSearchResults({
    searchString,
    enabled,
}: UseGlobalSearchResultsOptions) {
    return useQuery({
        queryKey: ['global-search', searchString],

        queryFn: searchString.trim()
            ? async () => sdClient.getGlobalSearchResponses({ searchTerm: searchString })
            : skipToken,

        placeholderData: keepPreviousData,
        enabled,
    });
}
